export enum CarStatusFilter {
  UPCOMING = 'upcoming',
  ACTIVE = 'active',
  ENDED = 'ended',
}
